import {Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { GridApi, GridOptions } from 'ag-grid-community';
import { HospitalAdministrationService } from '../../../../hospital-administration/hospital-administration.service';
import { CustomPaginationComponent } from '../../grid-renderers/custom-pagination/custom-pagination.component';
import { restoreGridOverlays, restoreRowSelection } from '../../../services/ag-grid-compat';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'hospitals-grid-modal',
  templateUrl: './hospitals-grid-modal.component.html'
})
export class HospitalsGridModalComponent implements OnInit, OnDestroy {
  @Input() onlyActive: boolean = false;
  gridOptions: GridOptions = {};
  saveDisabled: boolean = true;
  private selectedRow: any;
  private gridApi: GridApi;
  private apiSubscription: Subscription;

  constructor(public activeModal: NgbActiveModal,
              private hospitalAdminService: HospitalAdministrationService) {}

  ngOnInit(): void {
    this.gridOptions.columnDefs = [
      { field: 'costCenter', headerName: 'SAP/Cost Center', width: 105, minWidth: 105, filterParams: {
          defaultOption: 'startsWith'
        } },
      { field: 'name', headerName: 'Facility Name', minWidth: 300 },
      { field: 'status', headerName: 'Status', width: 100, minWidth: 100,
        filterParams: {
          defaultOption: 'startsWith'
        }
      }
    ];
    this.gridOptions.components = {};
    this.gridOptions.defaultColDef = {
      sortable: true,
      resizable: true,
      filter: 'agTextColumnFilter',
      filterParams: {
        defaultOption: 'contains'
      }
    };
    this.gridOptions.defaultColDef.floatingFilter = true;
    this.gridOptions.pagination = true;
    this.gridOptions.paginationPageSize = 25;
    this.gridOptions.suppressCellFocus = true;
    this.gridOptions.singleClickEdit = false;
    this.gridOptions.components = {
      customPaginationComponent: CustomPaginationComponent
    };
    this.gridOptions.suppressPaginationPanel = true;
    this.gridOptions.statusBar = {
      statusPanels: [
        {
          statusPanel: 'customPaginationComponent',
          statusPanelParams: {
            pageSizes: [25, 50, 75, 100],
            pageSize: 25
          }
        }
      ],
    };
    this.gridOptions.context = {
      componentParent: this
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    restoreGridOverlays(this.gridApi);
    restoreRowSelection(this.gridApi, 'single');
    this.gridApi.showLoadingOverlay();
    this.gridApi.sizeColumnsToFit();
    this.apiSubscription = this.hospitalAdminService.getHospitalsByUserName()
      .subscribe(res => {
        this.gridOptions.rowData = res.data;
        this.gridApi.hideOverlay();
      },() => {
        this.gridApi.hideOverlay();
        this.gridOptions.rowData = [];
      });
  }

  onFirstDateRendered() {
    if (this.onlyActive) {
      this.gridApi.setFilterModel({
        status: {
          filterType: 'text',
          type: 'equals',
          filter: 'active'
        }
      });
    }
  }

  rowSelected(event) {
    this.selectedRow = event.data;
    this.saveDisabled = false;
  }

  saveData() {
    if(!this.saveDisabled) {
      this.activeModal.close(this.selectedRow);
    }
  }

  ngOnDestroy() {
    if (this.apiSubscription){
      this.apiSubscription.unsubscribe();
    }
  }

}
